import { ColorTree } from "lib/generateColorConfig";

export const colors: ColorTree = {
  blue: {
    100: { light: "#bef264", dark: "#bef264" },
    300: { light: "#a3e635", dark: "#a3e635" },
    400: { light: "#84cc16", dark: "#84cc16" },
    500: { light: "#84cc16", dark: "#84cc16" },
    600: { light: "#65a30d", dark: "#65a30d" },
    700: { light: "#4d7c0f", dark: "#4d7c0f" },
  },
  "cold-blue": {
    500: { light: "#1a1a1a", dark: "#1a1a1a" },
    700: { light: "#0f0f0f", dark: "#0f0f0f" },
    900: { light: "#f0fdf4", dark: "#0a0a0a" },
  },
  slate: {
    100: { light: "#6b7280", dark: "#9ca3af" },
    400: { light: "#9ca3af", dark: "#d1d5db" },
    500: { light: "#d1d5db", dark: "#4b5563" },
    600: { light: "#e5e7eb", dark: "#1f1f1f" },
    700: { light: "#f3f4f6", dark: "#171717" },
    750: { light: "#f9fafb", dark: "#0f0f0f" },
    800: { light: "#f9fafb", dark: "#0d0d0d" },
    900: { light: "#ffffff", dark: "#0a0a0a" },
    950: { light: "#fafafa", dark: "#050505" },
  },
  gray: {
    50: { light: "rgba(0, 0, 0, 0.95)", dark: "rgba(255, 255, 255, 0.95)", type: "rgba" },
    100: { light: "#333333", dark: "#e7e7e9" },
    200: { light: "#555555", dark: "#cfcfd3" },
    300: { light: "#777777", dark: "#b7b8bd" },
    400: { light: "#999999", dark: "#9fa0a7" },
    500: { light: "#BBBBBB", dark: "#878891" },
    600: { light: "#DDDDDD", dark: "#70707c" },
    700: { light: "#F0F0F0", dark: "#585866" },
    800: { light: "rgba(0, 0, 0, 0.2)", dark: "rgba(255, 255, 255, 0.2)", type: "rgba" },
    900: { light: "rgba(0, 0, 0, 0.1)", dark: "rgba(255, 255, 255, 0.1)", type: "rgba" },
    950: { light: "rgba(0, 0, 0, 0.05)", dark: "rgba(255, 255, 255, 0.05)", type: "rgba" },
  },
  yellow: {
    300: { light: "#FF9400", dark: "#ffe166" },
    500: { light: "#f3b50c", dark: "#f3b50c" },
    900: { light: "#FFF9D0", dark: "#2E2D29" },
  },
  red: {
    100: { light: "#EA2A46", dark: "#F9A4A5" },
    400: { light: "#ff637a", dark: "#ff637a" },
    500: { light: "#EA2A46", dark: "#FF506A" },
    700: { light: "#B33055", dark: "#B33055" },
    900: { light: "#F9E2E5", dark: "#2D192D" },
  },
  green: {
    100: { light: "#84cc16", dark: "#bef264" },
    300: { light: "#a3e635", dark: "#a3e635" },
    400: { light: "#bef264", dark: "#bef264" },
    500: { light: "#84cc16", dark: "#84cc16" },
    600: { light: "#f0fdf4", dark: "#1a2e05" },
    700: { light: "#84cc16", dark: "#84cc16" },
    800: { light: "#65a30d", dark: "#65a30d" },
    900: { light: "#f0fdf4", dark: "#0f1a00" },
  },
  white: { light: "#ffffff", dark: "#ffffff" },
  black: { light: "#000000", dark: "#000000" },
  button: {
    secondary: { light: "#e5e7eb", dark: "#1f1f1f" },
    secondaryHover: { light: "#d1d5db", dark: "#2a2a2a" },
    secondaryDisabled: { light: "#e5e7eb", dark: "#171717" },
    primaryHover: { light: "#65a30d", dark: "#a3e635" },
    primaryActive: { light: "#4d7c0f", dark: "#bef264" },
  },
  fill: {
    surfaceElevated50: { light: "#f3f4f680", dark: "#14140f80" },
    surfaceElevated: { light: "#f3f4f6", dark: "#141414" },
    surfaceElevatedHover: { light: "#e5e7eb", dark: "#1a1a1a" },
    surfaceHover: { light: "#6b728014", dark: "#9ca3af14" },
    accent: { light: "#e5e7eb", dark: "#1f1f1f" },
  },
  typography: {
    primary: { light: "#000000", dark: "#ffffff" },
    secondary: { light: "#696D96", dark: "#a0a3c4" },
    inactive: { light: "#C4C4D5", dark: "#3E4361" },
  },
};
